import axios from 'axios';
import RouteUrls from '../common/RouteUrls';
import {getAuthToken, getXSRFToken} from '../common/authTokenUtil';

export const index = async () => {

  try {
    const response = await axios({
      method: 'GET',
      url: RouteUrls.INDEX_ENDPOINT,
      headers: {
        'correlation-id': '12345',
        'client-id': 'PNET'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in mounting : ', error);
    throw error;
  }
}

export const login = async (formData, orgId, userId, password, rememberOrganization, deviceId, deviceSignature, csrf) => {

  const headers = {
    accept: 'application/json',
    'content-type': 'application/json',
    'correlation-id':
      '12345',
    'client-id':
      'PNET',
    'device-id': deviceId || '',
    'backdoorEnabled': 'false'
  }

  // Fix for fallback logic
  let rememberOrgValue = false; // Default to false

  // Check if rememberOrganization parameter has a valid value
  if (rememberOrganization === true || rememberOrganization === false) {
    rememberOrgValue = rememberOrganization;
  }
  // If not, check if formData has rememberOrganization property with a valid value
  else if (formData && formData.rememberOrganization === true || formData.rememberOrganization === false) {
    rememberOrgValue = formData.rememberOrganization;
  }

  const requestData = {
    organizationNumber: orgId,
    loginName: userId,
    secretPhrase: password,
    rememberOrg: rememberOrgValue,
    deviceSignature: deviceSignature,
  }

  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.LOGIN_ENDPOINT,
      headers: headers,
      data: requestData
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user ID : ', error);
    throw error;
  }
};

export const sendAnotherRegistrationAccessCode = async (organizationNumber, userId, secretPhrase, deviceSignature) => {

  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.SEND_ANOTHER_REGISTRATION_ACCESS_CODE_ENDPOINT,
      headers: {
        'correlation-id': '12345',
        'client-id': 'PNET'
      },
      data: {
        organizationNumber: organizationNumber,
        loginName: userId,
        secretPhrase: secretPhrase,
        deviceSignature: deviceSignature
      }
    });
    return response.data;
  } catch (e) {
    console.error('Error Sending another access code: ', e);
    throw e;
  }

}

export const registerDevice = async (deviceSignature, accessCode, password, organizationNumber, userId, authJwtToken) => {

  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.REGISTER_DEVICE_ENDPOINT,
      headers: {
        'correlation-id': '12345',
        'client-id': 'PNET',
        'Authorization': `Bearer ${authJwtToken}`
      },
      data: {
        organizationNumber: organizationNumber,
        userId: userId,
        password: password,
        deviceSignature: deviceSignature,
        accessCode: accessCode,
        // deviceSignature: deviceSignature,
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user ID : ', error);
    throw error;
  }
}

export const deRegisterDevice = async (deviceSignature, organizationNumber, userId) => {

  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.DEREGISTER_DEVICE_ENDPOINT,
      headers: {
        'correlation-id': '12345',
        'client-id': 'PNET',
      },
      data: {
        organizationNumber: organizationNumber,
        userId: userId,
        deviceSignature: deviceSignature,
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user ID : ', error);
    throw error;
  }
}

export const success = async (orgName, loginName) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.SUCCESS_ENDPOINT,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id': '12345'
      },
      data: {
        organizationNumber: orgName,
        loginName: loginName,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


export const timeOut = async () => {
  try {
    const response = await axios(
      {
        method: 'POST',
        url: RouteUrls.SESSION_TIMEOUT_ENDPOINT,
        headers: {
          'client-id':
            'PNET',
        },
        data: {}
      }
    );

    return response.data;

  } catch (error) {
    console.error('Error fetching session timeout : ', error);
    throw error;
  }
}
